// removed by extract-text-webpack-plugin
module.exports = {"root":"_1nH-y","container":"_14c18"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/TestimonialBlock/TestimonialBlock.scss
// module id = 1365
// module chunks = 3